import type {ButtonHTMLAttributes, DetailedHTMLProps, HTMLAttributes} from 'react';

export type MapboxControlButtonProps = DetailedHTMLProps<
    ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
>;

export function MapboxControlButton({style = {}, ...props}: MapboxControlButtonProps) {
    return (
        <button
            style={{
                height: 30,
                width: 30,
                padding: 3,
                textAlign: 'center',
                ...style,
            }}
            {...props}
        />
    );
}

export function MapboxControlGroup({...props}: HTMLAttributes<HTMLDivElement>) {
    return <div className='mapboxgl-ctrl mapboxgl-ctrl-group' {...props} />;
}
